import { render } from "./Experience.vue?vue&type=template&id=07975645"
import script from "./Experience.vue?vue&type=script&lang=js"
export * from "./Experience.vue?vue&type=script&lang=js"
script.render = render

export default script